// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBZMVrgkAWBeQTKXlRSOb4CiG5dAYppeno",
  authDomain: "risen-journal.firebaseapp.com",
  projectId: "risen-journal",
  storageBucket: "risen-journal.firebasestorage.app",
  messagingSenderId: "697168409003",
  appId: "1:697168409003:web:720d1b231a798d9ad3a2ee"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
